import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GppBadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"gpp_bad"}/>
}
